//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SEO from '~/mixins/SEO.js'
import JSONSCHEMA from '~/mixins/JSONSCHEMA.js'
export default {
    name: 'index',
    mixins: [SEO,JSONSCHEMA],
    data: () => ({
        currentPage: 1,
    }),

    methods: {
        async fetchDoctorsInCityInSpecializations(index) {
            if(this.$route.query.page != index){
                this.$route.query.page = index
                const doctor = await this.$api.fetchDoctorsInCityInSpecializations(this.$route.params.country,this.$route.params.city,this.$route.params.specialization,index)
                this.page = doctor.content
                // window.scrollTo(0,0);
                this.currentPage = index
            }
        }
    },

    async asyncData({ app, params, error }) {
  try {
    const response = await app.$api.fetchDoctorsInCityInSpecializations(params.country, params.city, params.specialization, 1);
    return { page: response.content };
  } catch (e) {
    error({ statusCode: 404 });
  }
},
}
